import React, { useState } from "react";
import {
    Box,
    Typography,
    Switch,
    FormControlLabel,
    Paper,
    Fade,
    Chip,
    Stack,
    CircularProgress,
} from "@mui/material";
import { AdminPanelSettings, Person } from "@mui/icons-material";
import AdminDashboard from "./AdminDashboard";
import UserDashboard from "./UserDashboard";
import { usePermissions } from "../rbac/PermissionsProvider";
import { PERMISSIONS } from "../rbac/permissions";

export default function UnifiedDashboard() {
    const [isAdminView, setIsAdminView] = useState(true);
    const { can, loading } = usePermissions();
    // Admin View lists every cost sheet; everyone else only gets their own (User View).
    const canViewAll = can(PERMISSIONS.COSTSHEET_VIEW_ALL);
    const showAdminView = canViewAll && isAdminView;

    const handleChange = (event) => {
        // Switch ON = User Dashboard, OFF = Admin Dashboard
        setIsAdminView(!event.target.checked);
    };

    return (
        <Box sx={{ minHeight: "100vh", bgcolor: "#f8fafc", p: 3 }}>
            <Paper
                elevation={0}
                sx={{
                    p: 3,
                    mb: 4,
                    borderRadius: 4,
                    background: "linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)",
                    color: "white",
                    boxShadow: "0 10px 30px rgba(59,130,246,0.25)",
                }}
            >
                <Stack
                    direction={{ xs: "column", md: "row" }}
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={3}
                >
                    <Box>
                        <Typography variant="h4" color="white" fontWeight={700} gutterBottom>
                            Dashboard
                        </Typography>
                        <Typography variant="body1" sx={{ opacity: 0.9 }} color="white">
                            {canViewAll ? "Seamlessly switch between Admin and User Dashboards" : "Your cost sheets and deliveries"}
                        </Typography>
                    </Box>

                    {canViewAll && (
                    <Paper
                        sx={{
                            px: 3,
                            py: 1.5,
                            borderRadius: 3,
                            bgcolor: "rgba(255,255,255,0.15)",
                            backdropFilter: "blur(10px)",
                        }}
                    >
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={!isAdminView}
                                    onChange={handleChange}
                                    color="default"
                                />
                            }
                            label={
                                <Stack direction="row" spacing={1} alignItems="center">
                                    {isAdminView ? <AdminPanelSettings /> : <Person />}
                                    <Chip
                                        label={isAdminView ? "Admin View" : "User View"}
                                        color={isAdminView ? "warning" : "success"}
                                        size="small"
                                    />
                                </Stack>
                            }
                            labelPlacement="start"
                        />

                    </Paper>
                    )}
                </Stack>
            </Paper>

            {loading ? (
                <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
                    <CircularProgress />
                </Box>
            ) : (
                <Fade in timeout={500} key={showAdminView ? "admin" : "user"}>
                    <Box data-testid={showAdminView ? "admin-view" : "user-view"}>
                        {showAdminView ? <AdminDashboard /> : <UserDashboard />}
                    </Box>
                </Fade>
            )}
        </Box>
    );
}